import {
  Component,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
  ComponentRef,
  EventEmitter,
  Output,
  Input,
  ChangeDetectorRef
} from '@angular/core';

@Component({
    selector: 'confirm',
    templateUrl: './confirm.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
/**
 * API to an open modal window.
 */
export class ConfirmComponent {
  /**
   * Caption for the title.
   */
  @Input() public title: string;
  @Input() public danger: string;
  /**
   * component which is to be loaded dynamically.
   */
  public component: any;
  /**
   * Describes if the modal contains Ok Button.
   * The default Ok button will close the modal and emit the callback.
   * Defaults to true.
   */
  public okButton: boolean = true;
  /**
   * Caption for the OK button.
   * Default: Ok
   */
  public defaultokButtonText: string = 'Ok';
  @Input() public okButtonText: string = this.defaultokButtonText;

  /**
   * Describes if the modal contains cancel Button.
   * The default Cancelbutton will close the modal.
   * Defaults to true.
   */
  public cancelButton: boolean = true;
  public closeButton: boolean = true;
  /**
   * Caption for the Cancel button.
   * Default: Cancel
   */
  public defaultCancelButtonText: string = 'Cancel';
  @Input() public cancelButtonText: string = this.defaultCancelButtonText;
  /**
   * if the modalMessage is true it will show the message inside modal body.
   */
  public modalMessage: boolean = true;
  /**
   * Some message/content can be set in message which will be shown in modal body.
   */
  @Input() public message: string;
  @Input() public center = true;
  /**
   * if the value is true modal footer will be visible or else it will be hidden.
   */
  public modalFooter: boolean = true;
  /**
   * shows modal header if the value is true.
   */
  public modalHeader: boolean = true;
  /**
   * if the value is true modal will be visible or else it will be hidden.
   */
  public isOpen: boolean = false;
  /**
   * Emitted when a ok button was clicked
   * or when close method is called.
   */
  /**
   * shows warning icon if the value is true.
   */
  public warningIcon: boolean = false;

  public initialData: any;

  cmpRef: ComponentRef<any>;
  //@ViewChild(OpenDirective) componentDirective: OpenDirective;
  @ViewChild('child', { read: ViewContainerRef, static: true }) target: ViewContainerRef;
  @Output() public confirmOutput: EventEmitter<any> = new EventEmitter();
  @Output() public modalClosed: EventEmitter<any> = new EventEmitter();
  constructor(
    public componentFactoryResolver: ComponentFactoryResolver,
    public viewContainer: ViewContainerRef,
    private cdf: ChangeDetectorRef
  ) {}
  open(component?: any, data?: any) {
    this.initialData = data;
    this.isOpen = true;
    this.cdf.detectChanges();
  }
  /**
   *  close method dispose the component, closes the modal and optionally emits confirmOutput value.
   */
  close(data?: any) {
    this.dispose();
    if (data) {
      this.confirmOutput.emit(data);
    } else if (this.modalClosed) {
      this.modalClosed.emit(null);
    }
  }
  /**
   *  ok method dispose the component, closes the modal and emits true.
   */
  submit() {
    this.dispose();
    if (this.initialData) {
      this.confirmOutput.emit({ value: true, initialData: this.initialData });
    } else {
      this.confirmOutput.emit(true);
    }
  }
  /**
   *  dispose method dispose the loaded component.
   */
  dispose() {
    this.isOpen = false;
    if (this.component != undefined) {
      this.component.then((componentRef: ComponentRef<any>) => {
        componentRef.destroy();
        return componentRef;
      });
    }
  }
}
